export type article = 'a' | 'an'

export const getArticle = (word: string) => {
  const vowels = ['a', 'e', 'i', 'o', 'u']
  return vowels.includes(word.charAt(0)) ? ('an' as article) : ('a' as article)
}
